module.exports = __webpack_public_path__ + "img/mainmenbuttonPressed.a9c50008.png";